import path from 'ramda/src/path';

export const updateCurrenciesInEntity = async (currencies, updateFunction, updateFunctionParams) => {
  const { payload: updated } = await updateFunction({ additionalData: { currencies } }, updateFunctionParams);

  return path(['additionalData', 'currencies'], updated);
};
